import type { DecorationSet } from '@atlaskit/editor-prosemirror/view';

import type { ReadingAidsPopupPropsInState } from './types';

export enum AIDefinitionsActionType {
	UPDATE_SESSION_ID = 'UPDATE_SESSION_ID',

	UPDATE_KEYWORD_DECORATIONS = 'UPDATE_KEYWORD_DECORATIONS',

	OPEN_READING_AIDS_POPUP = 'OPEN_READING_AIDS_POPUP',

	CLOSE_READING_AIDS_POPUP = 'CLOSE_READING_AIDS_POPUP',

	SET_CURRENT_KEYWORD_ID = 'SET_CURRENT_KEYWORD_ID',

	RESET_CURRENT_KEYWORD_ID = 'RESET_CURRENT_KEYWORD_ID',
}

interface UpdateSessionId {
	type: AIDefinitionsActionType.UPDATE_SESSION_ID;
	sessionId: string;
}

interface UpdateDecorations {
	type: AIDefinitionsActionType.UPDATE_KEYWORD_DECORATIONS;
	keywordDecorations: DecorationSet;
}

interface OpenReadingAidsPopup {
	type: AIDefinitionsActionType.OPEN_READING_AIDS_POPUP;
	readingAidsPopupProps: ReadingAidsPopupPropsInState;
}

interface CloseReadingAidsPopup {
	type: AIDefinitionsActionType.CLOSE_READING_AIDS_POPUP;
}

interface SetCurrentKeywordId {
	type: AIDefinitionsActionType.SET_CURRENT_KEYWORD_ID;
	keywordId: string;
}

interface ResetCurrentKeywordId {
	type: AIDefinitionsActionType.RESET_CURRENT_KEYWORD_ID;
}

export type AIDefinitionsAction =
	| UpdateSessionId
	| UpdateDecorations
	| OpenReadingAidsPopup
	| CloseReadingAidsPopup
	| SetCurrentKeywordId
	| ResetCurrentKeywordId;
